import React from 'react';
import type { WebSolution } from '@wix/ambassador-marketplace/types';

interface ISolutionPageContext {
  app: WebSolution;
}
export const SolutionPageCtx = React.createContext<ISolutionPageContext>(null);
